var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoCotizaloAhora(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4328",
    "data-name": "Group 4328",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.014,
    height: 27.013,
    viewBox: "0 0 27.014 27.013",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #002e6b;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3656",
    "data-name": "Rectangle 3656",
    className: "cls-1",
    width: 27.013,
    height: 27.013
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4318",
    "data-name": "Group 4318",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7499",
    "data-name": "Path 7499",
    className: "cls-1",
    d: "M13.507,0A13.507,13.507,0,1,0,27.013,13.507,13.506,13.506,0,0,0,13.507,0m0,26.031A12.524,12.524,0,1,1,26.031,13.507,12.538,12.538,0,0,1,13.507,26.031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7500",
    "data-name": "Path 7500",
    className: "cls-1",
    d: "M18.076,36.872h-.982a5.138,5.138,0,0,0,4.173,5.206v2.166h.982V41.262s-4.173-.287-4.173-4.39",
    transform: "translate(-9.689 -20.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7501",
    "data-name": "Path 7501",
    className: "cls-1",
    d: "M24.945,25.485v3h.982V26.294c2.54-.6,4.1-2.33,4.1-4.592,0-3.683-2.993-4.369-5.178-4.871-1.688-.387-2.483-.647-2.483-1.355,0-.661.708-1.105,1.762-1.105a1.977,1.977,0,0,1,2.02,1.333h3.543a4.441,4.441,0,0,0-3.763-4.732v-1.9H22.07v2.016a4.737,4.737,0,0,0-3.56,4.566c0,3.636,2.964,4.316,5.128,4.814,1.667.383,2.453.639,2.453,1.332,0,1.033-1.4,1.144-2,1.144-1.441,0-2.336-.7-2.336-1.831h-.982c0,1.682,1.334,2.813,3.318,2.813,2.2,0,2.984-1.1,2.984-2.127,0-1.551-1.634-1.926-3.215-2.289-2.146-.493-4.366-1.051-4.366-3.856,0-3.265,3.56-3.8,3.56-3.8v-1.8h1.893v1.75s3.3.108,3.73,2.913H26.747a2.88,2.88,0,0,0-2.618-1.333c-1.616,0-2.745.859-2.745,2.088,0,1.568,1.65,1.947,3.246,2.312,2.171.5,4.415,1.013,4.415,3.914,0,0,.257,3.084-4.1,3.783",
    transform: "translate(-10.492 -5.145)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCotizaloAhora);
export default __webpack_public_path__ + "static/media/Logo_CotizaloAhora.fcca41ebf6ce02d337533dcd851e4ced.svg";
export { ForwardRef as ReactComponent };